export var RecorderStatus;
(function (RecorderStatus) {
    RecorderStatus["READY"] = "READY";
    RecorderStatus["RECORDING"] = "RECORDING";
    RecorderStatus["PAUSED"] = "PAUSED";
    RecorderStatus["STOPPED"] = "STOPPED";
    RecorderStatus["PLAYBACK"] = "PLAYBACK";
    RecorderStatus["UPLOADING"] = "UPLOADING";
    RecorderStatus["ERROR"] = "ERROR";
})(RecorderStatus || (RecorderStatus = {}));
export var MediaSource;
(function (MediaSource) {
    MediaSource["Audio"] = "audio";
    MediaSource["Video"] = "video";
    MediaSource["Screen"] = "screen";
})(MediaSource || (MediaSource = {}));
